import React from 'react';
import { IndexCoordinatorDelegate } from "../IndexCoordinator";
import { DengueActivitiesViewControllerDelegate, DengueActivitiesViewController } from "../../Screen/DengueActivities/DengueActivitiesViewController";
import { TableGenericViewControllerDelegate, TableGenericViewController } from "../../Screen/TableGeneric/TableGenericViewController";
import { TableGenericViewModel } from "../../Screen/TableGeneric/TableGenericViewModel";
import { DengueActivitiesViewModel } from '../../Screen/DengueActivities/DengueActivitiesViewModel';
import ProtectedRoute from '../../Components/ProtectedRoute';

export class DengueActivitiesCoordinator implements IndexCoordinatorDelegate, DengueActivitiesViewControllerDelegate, TableGenericViewControllerDelegate {

    getRoute(): JSX.Element[] {
        return [
            this.routeTable(),
            this.routeForm()
        ]
    }

    private routeTable(): JSX.Element {
        var viewModel = new TableGenericViewModel("gepatividadedengue")
        return (<ProtectedRoute requiredPermissions={['dengue.atividade.*']} path="/:base/dengue/atividade" exact={true} component={(props: any) => {
            return (<TableGenericViewController
                permissions={{
                    add: 'dengue.atividade.adicionar',
                    edit: 'dengue.atividade.editar',
                    delete: 'dengue.atividade.excluir',
                }}
                navigation={props}
                viewModel={viewModel}
                delegate={this}
                title={"Atividades"}
            />)
        }} />)
    }

    private routeForm(): JSX.Element {
        var viewModel = new DengueActivitiesViewModel()
        return (<ProtectedRoute requiredPermissions={['dengue.atividade.adicionar', 'dengue.atividade.editar']} path="/:base/dengue/atividade/cad/:id" exact={true} component={(props: any) => {
            var idPk = props.match.params.id
            return (<DengueActivitiesViewController
                navigation={props}
                viewModel={viewModel}
                delegate={this}
                idPrimary={idPk}
            />)
        }} />)
    }

    tapDimiss(navigation: any): void {
        navigation.history.goBack();
    }

    add(navigation: any, viewModel: TableGenericViewModel): void {
        if (viewModel.getTable() == "gepatividadedengue") {
            navigation.history.push(`atividade/cad/0`);
            return;
        }
    }

    edit(navigation: any, idSelection: number, viewModel: TableGenericViewModel): void {
        if (viewModel.getTable() == "gepatividadedengue") {
            navigation.history.push(`atividade/cad/${idSelection}`);
            return;
        }
    }

}